import { render, staticRenderFns } from "./PrizeDrawCommentsByPerson.vue?vue&type=template&id=7ab02f58&scoped=true"
import script from "./PrizeDrawCommentsByPerson.vue?vue&type=script&lang=js"
export * from "./PrizeDrawCommentsByPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab02f58",
  null
  
)

export default component.exports